module.exports = __webpack_public_path__ + "img/asiainsta.2e8c21bd.jpg";